import { Check, Close } from "@mui/icons-material";
import { Box, InputBase } from "@mui/material";
import React, { useState } from "react";
import { deleteNote, getNotes, noteStore } from "../../api/user";
import BookmarkIcon from "../../assets/SVG/bookmarkIcon";
import DeleteIcon from "../../assets/SVG/deleteIcon";

export default function NoteCard({ data, setNoteData, setShowNewNote }) {
  const [titleValue, setTitleValue] = useState();
  const [textValue, setTextValue] = useState();
  // console.log(textValue);
  return (
    <>
      <Box
        bgcolor="#F5F9FF"
        width="240px"
        p="20px"
        height="242px"
        borderRadius={"13px"}
        position="relative"
      >
        <Box
          justifyContent={"space-between"}
          display="flex"
          alignItems="center"
        >
          <Box>امروز</Box>
          <Box gap="10px" display={"flex"} alignItems="center">
            <Box
              mt="5px"
              onClick={() => {
                deleteNote(data?.id)
                  .then(() => {
                    getNotes()
                      .then((x) => setNoteData(x))
                      .catch(() => {});
                  })
                  .catch(() => {});
              }}
            >
              <DeleteIcon size={"1.4"} />
            </Box>
            <BookmarkIcon />
          </Box>
        </Box>
        <InputBase
          value={titleValue || data?.title}
          onChange={(e) => {
            if (!data) {
              setTitleValue(e.target.value);
            }
          }}
          placeholder="عنوان"
          sx={{ fontSize: "20px", mt: "10px" }}
        />
        <Box sx={{ height: "1px", bgcolor: "#DDDDDD", my: "5px" }}></Box>
        <InputBase
          value={textValue || data?.description}
          onChange={(e) => {
            if (!data) {
              setTextValue(e.target.value);
            }
          }}
          placeholder="چیزی بنویسید..."
          sx={{
            fontSize: "18px",
            overflow: "auto",
            maxHeight: "150px",
            width: "100%",
          }}
          multiline
        />
        {!data && (
          <Box position={"absolute"} bottom="10px" left="10px">
            <Close
              sx={{
                bgcolor: "#C98585",
                p: "3px",
                borderRadius: "50%",
                color: "white",
                cursor: "pointer",
                ml: "5px",
              }}
            />
            <Check
              sx={{
                bgcolor: "#85C99C",
                p: "3px",
                borderRadius: "50%",
                color: "white",
                cursor: "pointer",
              }}
              onClick={() =>
                noteStore({
                  title: titleValue,
                  description: textValue,
                }).then(() =>
                  getNotes()
                    .then((x) => {
                      setNoteData(x);
                      setShowNewNote(false);
                      setTextValue("");
                      setTitleValue("");
                    })
                    .catch(() => {})
                )
              }
            />
          </Box>
        )}
      </Box>
    </>
  );
}
